const commonTP: any = {
  'AppInsights-Common': {
    id: 'AppInsights-Common',
    displayName: 'Application Insights',
    domain: '',
    description: '',
    protocol: [
      'Proprietary',
      'Web.TPEngine.Providers.Insights.AzureApplicationInsightsProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    ],
    inputClaimsTransformations: [],
    inputClaims: [
      {
        claimTypeReferenceId: 'EventTimestamp',
        partnerClaimType: '{property:EventTimestamp}',
        defaultValue: '{Context:DateTimeInUtc}',
        required: false,
        alwaysUseDefaultValue: false,
      },
      {
        claimTypeReferenceId: 'tenantId',
        partnerClaimType: '{property:TenantId}',
        defaultValue: '{Policy:TrustFrameworkTenantId}',
        required: false,
        alwaysUseDefaultValue: false,
      },
      {
        claimTypeReferenceId: 'PolicyId',
        partnerClaimType: '{property:Policy}',
        defaultValue: '{Policy:PolicyId}',
        required: false,
        alwaysUseDefaultValue: false,
      },
      {
        claimTypeReferenceId: 'CorrelationId',
        partnerClaimType: '{property:CorrelationId}',
        defaultValue: '{Context:CorrelationId}',
        required: false,
        alwaysUseDefaultValue: false,
      },
      {
        claimTypeReferenceId: 'Culture',
        partnerClaimType: '{property:Culture}',
        defaultValue: '{Culture:RFC5646}',
        required: false,
        alwaysUseDefaultValue: false,
      },
    ],
    persistedClaims: [],
    outputClaims: [],
    outputClaimsTransformations: [],
    metadata: [
      ['InstrumentationKey', '{settings:aiInstrumentationKey}'],
      ['DeveloperMode', 'false'],
      ['DisableTelemetry ', 'false'],
    ],
    claimProvider: 'Application Insights',
    includeTechnicalProfile: '',
  },
  'AAD-Common': {
    id: 'AAD-Common',
    displayName: 'Azure Active Directory',
    domain: '',
    description: '',
    protocol: [
      'Proprietary',
      'Web.TPEngine.Providers.AzureActiveDirectoryProvider, Web.TPEngine, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null',
    ],
    inputClaimsTransformations: [],
    inputClaims: [],
    persistedClaims: [],
    outputClaims: [],
    outputClaimsTransformations: [],
    metadata: [
      ['ClientId', '{settings:extensionsContainerClientId}'],
      ['ApplicationObjectId', '{settings:extensionsContainerObjectId}'],
    ],
    claimProvider: 'Azure Active Directory',
    includeTechnicalProfile: '',
  },
};

const commonClaims: any = {
  'AppInsights-Common': {
    EventTimestamp: {
      id: 'EventTimestamp',
      displayName: 'Event timestamp',
      userInputType: '',
      dataType: 'string',
    },
    tenantId: {
      id: 'tenantId',
      displayName: "User's Object's Tenant ID",
      userInputType: '',
      dataType: 'string',
    },
    PolicyId: {
      id: 'PolicyId',
      displayName: 'Policy Id',
      userInputType: '',
      dataType: 'string',
    },
    CorrelationId: {
      id: 'CorrelationId',
      displayName: 'Correlation Id',
      userInputType: '',
      dataType: 'string',
    },
    Culture: {
      id: 'Culture',
      displayName: 'Culture ID',
      userInputType: '',
      dataType: 'string',
    },
  },
  'AAD-Common': {},
};

export { commonTP, commonClaims };
